import axios from "../../apis/axios";
import { getToken } from "../../utilities";

function useDownload({
  url = "product_excel_templte_download",
  onSuccess,
  onError,
  paramKey = "id", // <-- Add paramKey with default "id"
  // fileName = "template.xlsx", // <-- Remove fileName prop here
}) {
  const downloadFile = async (data, fileName = "template.xlsx") => {
    let fd = new FormData();
    fd.append(paramKey, data); // Use paramKey instead of hardcoded "id"
    // Append other data if needed
    // for (var key in data) {
    //     if (key !== 'id') {
    //         fd.append(key, data[key]);
    //     }
    // }
    try {
      const response = await axios({
        method: "POST",
        url: url,
        data: fd, // Data to be sent with the POST request
        responseType: "blob", // Important for downloading files
        headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
      });

      // Create a URL for the blob and trigger a download
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", fileName); // <-- Use fileName argument here
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(downloadUrl);

      onSuccess?.(response.data);
    } catch (error) {
      // Try to extract message from blob if present
      if (
        error.response.data instanceof Blob
      ) {
        error.response.data.text().then((text) => {
          let msg = "Unknown error";
          try {
            msg = JSON.parse(text).message || msg;
          } catch {}
          onError?.({ ...error, parsedMessage: msg });
        });
      } else {
        onError?.(error);
      }
    }
  };

  return { downloadFile };
}

export default useDownload;
